export type ReferralCodeStatus = "active" | "closed" | "deleted";

export const REFERRAL_CODE_STATUS_OPTIONS: Array<{
  value: ReferralCodeStatus;
  label: string;
  description: string;
}> = [
  {
    value: "active",
    label: "Active",
    description: "Accepts new signups and earns rewards from eligible purchases.",
  },
  {
    value: "closed",
    label: "Closed",
    description:
      "Blocks new signups while existing referred users remain eligible for rewards.",
  },
  {
    value: "deleted",
    label: "Deleted",
    description:
      "Permanently blocks signups, invalidates every existing referral, and cannot be replaced for this owner.",
  },
];

export type ReferralCodeUser = {
  user_id: number | string;
  firstname?: string | null;
  lastname?: string | null;
  email?: string | null;
  status?: string | null;
};

export type ReferralCode = {
  id: number;
  code: string;
  user_id: number | string;
  status: ReferralCodeStatus;
  user?: ReferralCodeUser | null;
  referred_users_count?: number;
  created_at?: string | null;
  updated_at?: string | null;
};

export type ReferralCodePayload = {
  code: string;
  user_id: number | string;
  status: ReferralCodeStatus;
};

export type ReferralCodeFilters = {
  search?: string;
  status?: ReferralCodeStatus | "";
  user_id?: number | string;
  page?: number;
  per_page?: number;
};

export type ReferralCodePagination = {
  data: ReferralCode[];
  current_page: number;
  last_page: number;
  per_page: number;
  total: number;
};

export type ReferralUserOption = ReferralCodeUser & {
  username?: string | null;
};
